import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface GetEvent {
	uriParams: Api.Operations['getEvent']['parameters']['path']
	params?: Api.Operations['getEvent']['parameters']['query']
	response: Api.Operations['getEvent']['responses']['200']['content']['application/json']
}

export const getEvent = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<GetEvent>(
		{
			method: 'get',
			url: '/events/{eventId}',
			...overideConfig,
		},
		axiosInstance,
	)
